/** Where a popularity figure came from, in one line. */

import type { DemandScore } from '@/api/client'

export function demandLine(d: DemandScore): string {
  switch (d.source) {
    case 'apple':
      return `Apple ${d.week ?? ''} 주`.replace('  ', ' ')
    case 'autocomplete':
      return `차트 밖 · 자동완성 ${d.hint_position}위`
    default:
      return d.hint_checked ? '차트 밖 · 자동완성에 없다' : '차트 밖 · 자동완성 미확인'
  }
}
